import { useMemo } from 'react';
import { Dropdown, Field } from '@carboledger/ui';
import { COUNTRY_CODES } from '@/config/countries.constants';
import { buildCountryCodeOptions } from '@/lib/utils';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   name  form field name — the site's own country, or one terminal's
 */
export const SiteCountryField = ({ name }) => {
  const t = useTranslations();
  const options = useMemo(() => buildCountryCodeOptions(COUNTRY_CODES), []);

  return (
    <Field name={name} required>
      {({ id, name: inputName, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          searchable
          id={id}
          name={inputName}
          label={t('FORM_COUNTRY_NAME')}
          placeholder={t('FORM_SELECT_COUNTRY')}
          searchPlaceholder={t('COMMON_SEARCH_COUNTRY')}
          noResultsMessage={t('COMMON_NO_MATCHES')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          options={options}
        />
      )}
    </Field>
  );
};
